import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=63908572"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&id=63908572&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports